<template>
  <div
    class="flex items-center gap-3 font-openSans uppercase text-white bg-purple text-[8px] py-3 px-6 text-center tablet:justify-start tablet:gap-x-16 laptop:px-[5rem] laptop:py-4">
    <div class="w-[50px] tablet:w-[60px]">
      <img alt="Logo do laboratório Ser" src="../../assets/logo-branca.png" />
    </div>
    <div
      class="grid grid-cols-2 content-center font-openSans gap-x-2 gap-y-2 items-center text-center tablet:grid-cols-5 md:gap-x-16">
      <nuxt-link to="../terms/of_use"><p class="tablet:w-16">Termos e condições</p></nuxt-link>
      <nuxt-link to="../terms/of_use"><p class="tablet:w-16">Política de privacidade</p></nuxt-link>
      <a href=" https://laboratoriodoser.substack.com/" target="_blank" rel="noopener noreferrer"><p class="tablet:w-16">Assine nossa Newsletter</p></a>
      <a href="https://wa.me/84559390326" target="_blank" rel="noopener noreferrer" class=""><p class="tablet:w-16">Fale com amanda estima</p></a>
          <nuxt-link href="https://www.instagram.com/amandaestima.psi" target="_blank" class="p-2 flex items-center rounded-full tablet:w-16">
            <Icon name="uil:instagram" size="28" />
          </nuxt-link>
    </div>


  </div>
  <div class=" text-white bg-black h-[14.86px] text-[9px] flex items-center justify-center">
    <p>Webdesign Gabriela Xavier | Desenvolvido por Cripsia Technology</p>
  </div>
</template>

<script>

export default {
  name: "FooterSite",

};
</script>

<style scoped>
/* Adicione aqui estilos específicos se necessário */
</style>
